import AppPageTemplate from '@/components/templates/AppPageTemplate';
import RadioButtonGroup from '@/components/molecules/RadioButtonGroup';
import { useOrganizationOnboardingStore } from '@/store/useOrganizationOnboardingStore';
import { OCCUPATIONS, OPTION_OTHER, OccupationFeBe } from '@/utils/demographicDataMappers';
import { Box, Button, Text, VStack } from '@chakra-ui/react';

type Props = { onContinue: () => void; onGoBack: () => void };

const Industry = ({ onContinue, onGoBack }: Props) => {
  const { industry, industryOther, setIndustry } = useOrganizationOnboardingStore();
  const valid = !!industry && (industry !== OPTION_OTHER || !!industryOther.trim());

  return (
    <AppPageTemplate>
      <VStack width={{ base: 'calc(100vw - 32px)', md: '750px' }} maxWidth="100%" spacing={0}>
        <Text
          as="h1"
          textAlign="center"
          variant="loraTitle"
          color="text.darkBlue"
          fontSize="26px"
          lineHeight="34px"
          fontWeight={400}
        >
          What is your organization’s main industry?
        </Text>
        <Text variant={'urbanistSemiBold'} textAlign="center" color="text.mediumGray" mt={7} maxWidth="610px">
          Your industry helps us identify trends across similar organizations and suggest relevant content, while
          keeping individual member data private.
        </Text>
        <Box width="100%" mt={16}>
          <RadioButtonGroup
            items={OCCUPATIONS}
            selectedItem={industry ?? ''}
            onClick={(value) => setIndustry(value as keyof typeof OccupationFeBe, industryOther)}
            textInputValue={industryOther}
            setTextInputValue={(value) => setIndustry(OPTION_OTHER, value)}
            separatorLineAfterIndex={3}
            width="min(100%, 365px)"
          />
        </Box>
        <Box width={{ base: '100%', md: '65%' }} height="2px" bg="background.separatorBlue" my={14} />
        <Button variant="continue" isDisabled={!valid} onClick={onContinue}>
          Continue
        </Button>
        <Button variant="link" color="text.mediumGray" my={10} onClick={onGoBack}>
          Go Back
        </Button>
      </VStack>
    </AppPageTemplate>
  );
};

export default Industry;
